import { topliApi } from '@/shared/api/topli/TopliApi'
import { WebinarsRequestParams } from '../model/types'
import { useQuery } from '@tanstack/react-query'

export const currentWebinarByIdQueryKey = 'currentWebinarById'
export const webinarListsByPageQueryKey = 'webinarListsByPage'

export const fetchWebinarListByPage = async (
  sort: string | null,
  limit: number,
  offset: number,
  search: string,
  language: string,
) => {
  const requestParams: WebinarsRequestParams = {
    limit,
    offset,
    sort,
    language,
  }

  if (search.length) {
    requestParams.name__icontains = search
  }

  const response = await topliApi.webinars.list(requestParams)
  return response
}

export const fetchWebinarById = async (id?: number) => {
  if (!id) return

  const response = await topliApi.webinars.get(id)
  return response
}

export const useWebinarsByPage = (
  sort: string | null,
  limit: number,
  page: number,
  search: string,
  language: string,
) =>
  useQuery({
    queryKey: [webinarListsByPageQueryKey, sort, page, limit, search || '', language],
    queryFn: () => fetchWebinarListByPage(sort, limit, page, search || '', language),
  })

export const useWebinarById = (id?: number) =>
  useQuery({
    queryKey: [currentWebinarByIdQueryKey, id],
    queryFn: () => fetchWebinarById(id),
    enabled: !!id,
  })
